import type { MaybeElementRef } from '@vueuse/core';
import { unrefElement } from '@vueuse/core';

export function focusFirst(container: MaybeElementRef) {
	const el = unrefElement(container);
	if (!el || !('querySelector' in el) || !(typeof el.querySelector === 'function')) return;

	const focusable = el.querySelector(':is(button, [href], input, select, textarea, [tabindex]):not([tabindex="-1"]):not(.hidden,.invisible,.opacity-0)');

	if (focusable && 'focus' in focusable && typeof focusable.focus === 'function') {
		// focusVisible only works on FF for now (06/2025), but you never know
		focusable.focus({ focusVisible: true });
	}
}
